module.exports = __webpack_public_path__ + "static/media/powerpoint.60dc0173.png";